<template>
  <nav class="navbar">
    <div class="nav-left">
      <div class="logo">
        <img
          src="/assets/tourbie.svg"
          alt="Tourbie Logo"
          class="logo-icon"
          width="28"
          height="28"
        />
        <span class="logo-text">Tourbie</span>
      </div>
    </div>
    <div class="nav-center">
      <a href="#" class="nav-link">Home</a>
      <a href="#" class="nav-link">Blogs</a>
      <a href="#" class="nav-link">Changelog</a>
      <a href="#" class="nav-link">Waitlist</a>
    </div>
  </nav>
</template>

<script>
export default {
  name: "NavbarSection",
};
</script>

<style scoped>
.logo-icon {
  color: var(--text-primary);
  min-width: 28px;
  transition: transform 0.2s ease;
  filter: brightness(0) invert(1);
}

.logo:hover .logo-icon {
  transform: scale(1.1);
}
</style>
